// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Id} from './id.js'

export class EntityAnchor {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): EntityAnchor {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsEntityAnchor(bb: flatbuffers.ByteBuffer, obj?: EntityAnchor): EntityAnchor {
    return (obj || new EntityAnchor()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsEntityAnchor(bb: flatbuffers.ByteBuffer, obj?: EntityAnchor): EntityAnchor {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new EntityAnchor()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  entities(index: number, obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Id()).__init(this.bb!.__vector(this.bb_pos + offset) + index * 8, this.bb!) : null
  }

  entitiesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  static startEntityAnchor(builder: flatbuffers.Builder) {
    builder.startObject(1)
  }

  static addEntities(builder: flatbuffers.Builder, entitiesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, entitiesOffset, 0)
  }

  static startEntitiesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(8, numElems, 4)
  }

  static endEntityAnchor(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    return offset
  }

  static createEntityAnchor(builder: flatbuffers.Builder, entitiesOffset: flatbuffers.Offset): flatbuffers.Offset {
    EntityAnchor.startEntityAnchor(builder)
    EntityAnchor.addEntities(builder, entitiesOffset)
    return EntityAnchor.endEntityAnchor(builder)
  }
}
